/* eslint-disable import/named */
import Vue from "vue";
import {
  Autocomplete,
  Checkbox,
  Dialog,
  Dropdown,
  Field,
  Input,
  Loading,
  Message,
  Modal,
  Notification,
  Radio,
  Tabs,
  Tag,
  Taginput,
  Toast,
  Tooltip,
} from "buefy";

export default function () {
  Vue.use(Autocomplete);
  Vue.use(Checkbox);
  Vue.use(Dialog);
  Vue.use(Dropdown);
  Vue.use(Field);
  Vue.use(Input);
  Vue.use(Loading);
  Vue.use(Message);
  Vue.use(Modal);
  Vue.use(Notification);
  Vue.use(Radio);
  Vue.use(Tabs);
  Vue.use(Tag);
  Vue.use(Taginput);
  Vue.use(Toast);
  Vue.use(Tooltip);
}
